var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowtieAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0707 8.71046C15.9502 9.53179 16.5 10.7017 16.5 12C16.5 13.2983 15.9502 14.4682 15.0707 15.2895L20.0107 18.8599C20.443 19.1724 21.0309 18.9381 21.1737 18.3964C22.2754 14.2158 22.2754 9.78422 21.1737 5.60359C21.0309 5.0619 20.443 4.82764 20.0107 5.14015L15.0707 8.71046Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92932 15.2895C8.04982 14.4682 7.5 13.2983 7.5 12C7.5 10.7017 8.04982 9.53179 8.92932 8.71046L3.98934 5.14015C3.55696 4.82764 2.96911 5.0619 2.82635 5.60359C1.72455 9.78422 1.72455 14.2158 2.82635 18.3964C2.96911 18.9381 3.55696 19.1724 3.98934 18.8599L8.92932 15.2895Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowtieAlt1);
export default __webpack_public_path__ + "static/media/bowtie-alt-1.a9cc8eb26e5041366e14aa7add7f824e.svg";
export { ForwardRef as ReactComponent };